var _rect, _path, _path2, _path3, _path4, _path5, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSound(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 44,
    viewBox: "0 0 45 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.903564,
    y: 0.500015,
    width: 43,
    height: 43,
    rx: 5.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0832 10C22.8257 10 22.5787 10.1023 22.3966 10.2843C22.2146 10.4666 22.1123 10.7134 22.1123 10.9709V33.0292C22.1123 33.3759 22.2974 33.6964 22.5977 33.87C22.8981 34.0434 23.2683 34.0434 23.5686 33.87C23.869 33.6964 24.0541 33.3759 24.0541 33.0292V10.9709C24.0541 10.7134 23.9518 10.4666 23.7697 10.2843C23.5877 10.1023 23.3406 10 23.0832 10Z",
    fill: "#3F4047"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9377 14.1648C27.6802 14.1648 27.4332 14.2671 27.2511 14.4494C27.0691 14.6314 26.9668 14.8783 26.9668 15.1357V28.7279C26.9668 29.0749 27.1519 29.3954 27.4522 29.5688C27.7526 29.7422 28.1227 29.7422 28.4231 29.5688C28.7235 29.3954 28.9085 29.0749 28.9085 28.7279V15.1357C28.9085 14.8783 28.8063 14.6314 28.6242 14.4494C28.4422 14.2671 28.1951 14.1648 27.9377 14.1648Z",
    fill: "#3F4047"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7919 18.3884C32.5345 18.3884 32.2874 18.4907 32.1054 18.673C31.9233 18.855 31.821 19.1018 31.821 19.3593V24.641C31.821 24.9878 32.0061 25.3083 32.3065 25.4816C32.6068 25.6552 32.977 25.6552 33.2774 25.4816C33.5777 25.3083 33.7628 24.9877 33.7628 24.641V19.3593C33.7628 19.1018 33.6605 18.855 33.4785 18.673C33.2964 18.4907 33.0494 18.3884 32.7919 18.3884Z",
    fill: "#3F4047"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2287 14.1648C17.9712 14.1648 17.7242 14.2671 17.5421 14.4494C17.3601 14.6314 17.2578 14.8783 17.2578 15.1357V28.7279C17.2578 29.0749 17.4429 29.3954 17.7432 29.5688C18.0436 29.7422 18.4138 29.7422 18.7141 29.5688C19.0145 29.3954 19.1996 29.0749 19.1996 28.7279V15.1357C19.1996 14.8783 19.0973 14.6314 18.9152 14.4494C18.7332 14.2671 18.4861 14.1648 18.2287 14.1648Z",
    fill: "#3F4047"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3744 18.3884C13.117 18.3884 12.8699 18.4907 12.6879 18.673C12.5059 18.855 12.4036 19.1018 12.4036 19.3593V24.641C12.4036 24.9878 12.5886 25.3083 12.889 25.4816C13.1894 25.6552 13.5595 25.6552 13.8599 25.4816C14.1602 25.3083 14.3453 24.9877 14.3453 24.641V19.3593C14.3453 19.1018 14.243 18.855 14.061 18.673C13.8789 18.4907 13.6319 18.3884 13.3744 18.3884Z",
    fill: "#3F4047"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.903564,
    y: 0.500015,
    width: 43,
    height: 43,
    rx: 5.5,
    stroke: "#E9ECEF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSound);
export default __webpack_public_path__ + "static/media/sound.187768d7.svg";
export { ForwardRef as ReactComponent };